import {RiSearchLine} from "react-icons/ri"
import {
    Checkbox,
    Flex,
    IconButton,
    Input,
    InputGroup,
    InputLeftElement,
    InputRightElement,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Tag,
    TagCloseButton,
    TagLabel,
    Text
} from "@chakra-ui/react"
import {ChevronDownIcon, CloseIcon} from "@chakra-ui/icons"

export function BrandSelector({brands, setBrands, availableBrands}) {
    function removeBrand(brand) {
        setBrands(prevBrands => prevBrands.filter(x => x.brand !== brand));
    }

    function handleCheckedboxChange(e) {
        if (e.target.checked) {
            console.log("CHECKKEED")
            let brandObj;
            for (const obj of availableBrands) {
                if (obj.brand === e.target.value) {
                    brandObj = obj;
                    break;
                }
            }
            setBrands(prevBrands => prevBrands.concat(brandObj));
        } else {
            removeBrand(e.target.value)
        }
    }

    return (<Flex bg='#fff' grow={1} minW='600px' h='44px' align='center'
                  p='8px 24px' borderRadius='100px' gap='8px'>
            <Text>Brands</Text>
            {brands.map((x) => <Tag h='28px' minW='60px' bg='rgba(0, 0, 0, 0.8)'
                                    color='#FFFFFFE5' key={x.brand}>
                <TagLabel>{x.brand_pretty_name}</TagLabel>
                <TagCloseButton onClick={() => removeBrand(x.brand)}/>
            </Tag>)
            }
            <Menu>
                <MenuButton as={IconButton} icon={<ChevronDownIcon/>} h='28px'/>
                <MenuList>
                    {availableBrands.map(x => <MenuItem key={x.brand}>
                        <Checkbox isChecked={brands.map(y => y.brand).includes(x.brand)}
                                  value={x.brand} key={x.brand}
                                  onChange={handleCheckedboxChange}>{x.brand_pretty_name}</Checkbox></MenuItem>)}
                </MenuList>
            </Menu>
        </Flex>
    )
}

export default function ParameterSelectionBar({
                                                  brands,
                                                  setBrands,
                                                  availableBrands,
                                                  searchQuery,
                                                  setSearchQuery,
                                              }) {


    return (
        <Flex gap='16px' p='0px' alignItems='flex-start' h='44px'>
            <InputGroup align='center' grow={0} w='400px'
            >
                <InputLeftElement
                    pointerEvents='none'
                    children={<RiSearchLine color='gray.300'/>}
                />
                <Input type='text' placeholder='Search Products...' value={searchQuery}
                       onChange={e => setSearchQuery(e.target.value)}
                       borderRadius='100px' bg='rgba(255, 255, 255, 0.9)' h='44px'/>
                <InputRightElement _hover={{cursor: "pointer"}}
                                   children={searchQuery.length > 0 ?
                                       <CloseIcon onClick={e => setSearchQuery("")}/> : null}/>
            </InputGroup>
            <BrandSelector brands={brands} setBrands={setBrands} availableBrands={availableBrands}/>

        </Flex>
    )
}